import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper"
import ListHeader from "@/common/components/ListHeader"
import Tabs from "@/common/components/Tabs"
import { SendHorizonal } from "lucide-react"
import { defaultTabs } from "../../constants/recipientMessagesTabs.constant"
import useUserPermissions from "@/common/hooks/useUserPermissions"

const List = () => {
  const { hasUserPermission, isUserPermissionsPending } = useUserPermissions()
  const hasFilterRecipientMessagesPermission = !isUserPermissionsPending ? hasUserPermission('Admin::Notifications::RecipientMessages::NotificationsFilter') : true

  return (
    <ErrorMessageWrapper
      className="max-h-[calc(100vh-64px)]"
      statusCode={hasFilterRecipientMessagesPermission ? 200 : 403}
    >
      <div className='max-h-[calc(100vh-64px)]'>
        <ListHeader
          Icon={<SendHorizonal className="w-10 h-10" strokeWidth={1.5} />}
          title="Envios"
        />

        <Tabs
          tabsListClassName="flex h-auto flex-row flex-wrap justify-start w-full bg-transparent rounded-none mt-4"
          tabsTriggerClassName="flex-1 h-8 transition-none duration-0 rounded-none border-b border-[#444444] text-white-800 text-xs data-[state=active]:bg-transparent data-[state=active]:text-white-800 data-[state=active]:shadow-none data-[state=active]:border-blue-800"
          tabsContentClassName="mt-6"
          tabsList={defaultTabs()}
        />
      </div>
    </ErrorMessageWrapper>
  )
}

export default List
